import styled from 'styled-components'
import { motion } from "framer-motion";
import AuthVector from '../../pages/auth/assets/AuthVector.svg'

export const AuthBody = styled.div`
position: relative;

   background: url(${AuthVector}) , ${(props) => props.theme.globalBg};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
	color: ${(props) => props.theme.textColor};
	direction: ${(props) => (props.theme.english ? 'ltr' : 'rtl')};
	font-family: ${(props) => (props.theme.english ? 'Metrophobic' : 'Kalameh')};
	/* letter-spacing: ${(props) => (props.theme.english ? '1.2px' : '1px')}; */
	height: 100%;
	min-height: 100vh;
	width: 100%;
	overflow: hidden;

`



const Flex = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
`

const MainWrapper = styled.div`
	position: relative;
  height: 100%;
	width: calc(100vw);
  margin-top: 35px;
	/* margin-right: ${(props) => !props.theme.english && '100px'}; */
	margin-left: ${(props) => props.theme.english && '280px'};
	margin-right: ${(props) => !props.theme.english && '280px'};

  `

const RespWrapper = styled.div`
	position: relative;
	width: 100%;
	padding: 10px 0px 60px 0px;
  margin-top: 80px;
  `


const MainBody = styled.div`
position: relative;
  padding: ${props => props.isAuthed ? "0 20px 20px 20px" : ""};
   background: url(${require('../../assets/images/trading-pro/main-bg.webp')}), ${(props) => props.theme.globalBg};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
	color: ${(props) => props.theme.textColor};
	direction: ${(props) => (props.theme.english ? 'ltr' : 'rtl')};
	font-family: ${(props) => (props.theme.english ? 'Metrophobic' : 'Kalameh')};
	/* letter-spacing: ${(props) => (props.theme.english ? '1.2px' : '1px')}; */
	height: 100%;
	min-height: 100vh;
	width: 100%;
	overflow: hidden;

`

const FiltersWrapper = styled(motion.div)`
  width: 100%;
  height: fit-content;
  position: fixed;
  bottom: 0px;
  z-index: 9999;
  padding: 20px;
  left: 0;
  background-color: ${props => props.theme.mainBg};
  
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  border: 1px solid #ffffff15;
`

const FiltersRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 0;
  &:not(:last-child) {
    border-bottom: 1px dashed ${props => `${props.theme.cardBorder}`};
  }
`

const FiltersText = styled.div`
	font-size: 0.9rem;
	color: ${props => props.color ? props.theme[props.color] : props.theme.textColor};
	
	@media screen and (max-width: 1050px) {
		font-size: 0.8rem;
	};
`

const FilterContent = styled.div`
  height: fit-content;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
`

const FilterButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
  height: 44px;
  width: 100%;
	border-radius: 8px;
	cursor: pointer;
	color: "#1E1E1E"; 
	background-color: ${props => props.theme.mainOrange};
	font-size: 14px;
`

const FilterCheckBox = styled.div`
  width: 14px;
  height: 14px;
  margin: 0 8px;
  position: relative;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`


const Filters = styled.div`
  border-radius: 5px;
  border: 1px solid ${props => `${props.theme.cardBorder}70`};
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FilterTag = styled.div`
  background-color: ${props => props.theme.tInputBg};
  border: 1px solid #ffffff15;
  border-radius: 12px;
  color: #c3c5b7;
  display: flex;
  padding: 4px 5px;
  font-size: 0.6rem;
  margin: 0 5px;
`

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Icon = styled.div`
  position: absolute;
  top: 50%;
  right: 10px; 
  transform: translateY(-50%);
  color: ${(props) => props.theme.inputPlaceHolder};
  &:hover {
    svg {
      transition: all 200ms ease-in-out;
      scale: 0.9;
    }
  }
`;

const Input = styled.input`
  width: 100%;
  height: 48px;
  outline: none;
  border: 1px solid
    ${(props) =>
    (props.status === 'valid' && props.theme.mainGreen) ||
    (props.status === 'error' && props.theme.mainRed) ||
    props.theme.mainColor};
  background-color: ${(props) => props.theme.input};
  color: ${(props) => props.theme.inputPlaceHolder};
  border-radius: 8px;
  margin-top: 5px;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 10px 20px;
  padding-right: ${props => props.hasIcon && '40px'};
  &:focus {
    border-color: ${(props) =>
    (props.status === 'valid' && props.theme.mainGreen) ||
    (props.status === 'error' && props.theme.mainRed) ||
    props.theme.mainColor};
  }
  @media screen and (max-width: 768px) {
    height: 42px;
  }
`;

export {
  Flex,
  MainWrapper,
  MainBody,
  RespWrapper,
  FiltersWrapper,
  FiltersRow,
  FiltersText,
  FilterContent,
  FilterButton,
  FilterCheckBox,
  Filters,
  FilterTag,
  InputWrapper,
  Icon,
  Input
}
